import React from 'react'
import './customernotification.scss'
import { Breadcrumb, CanadianCustomer, FindAgent, MainHeading, NewyorkCustomer, NoticeLinks } from '../../components';
import { Col, Container, Row } from 'react-bootstrap';
const CustomerNotifications = () => {
    const crumbsdata = [
        { label: 'Sentry Insurance home', link: '/' },
        { label: 'Customer notifications', link: '/footer/customer-notifications' }
    ]
    return (
        <div className='customer-notifications-wrapper'>
            <Container>
                <Breadcrumb crumbs={crumbsdata} />
                <MainHeading title="Customer notifications" showshare={false} />
                <div className='content-pages-wrapper'>
                    <Row>
                        <Col md={8} sm={12}  className='order-md-1 order-2'>
                            <NewyorkCustomer />
                            <CanadianCustomer />
                        </Col>
                        <Col md={4} sm={12}  className='order-md-2 order-1'>
                            <NoticeLinks />
                        </Col>
                    </Row>
                </div>
                <FindAgent />
            </Container>
        </div>
    )
}

export default CustomerNotifications;